import {
  request, setDataItem, getDataItem
} from "@/utils/utils.js";

const datasource = {
  SET_BASIC_DROPDOWN: 'SET_BASIC_DROPDOWN',
  SET_BASIC_REGIONS: 'SET_BASIC_REGIONS',
  SET_MERCHANT_NO: 'SET_MERCHANT_NO'
}
export default {
  namespaced: true,
  state: {
    basicDropdown: getDataItem('basicDropdown', 'datasource') || {},
    basicRegions: getDataItem('basicDropdown', 'datasource') || {},
    merchantNo: ''
  },
  mutations: {
    [datasource.SET_BASIC_DROPDOWN]: state => {
      setTimeout(async () => {
        if (!state.basicDropdown.apps) {
          let token = localStorage.getItem("Authorization");
          let url = "/api/dashboard/basic/getDropdown?access_token=" + token;
          request({
            method: "post",
            url,
          }).then((res) => {
            // 可以解析出以下数据
            // apps、carriers、chargeback_status、industry、method、order_currency、recurring_status、refund_status、regions、trade_status、withdraw_status
            state.basicDropdown = res.data
            setDataItem('basicDropdown', state.basicDropdown, 'datasource')
          });
        }
      }, 0)
    },
    [datasource.SET_BASIC_REGIONS]: state => {
      setTimeout(async () => {
        if (!state.basicRegions.countries) {
          let token = localStorage.getItem("Authorization");
          let url = "/api/dashboard/basic/regions?access_token=" + token;
          request({
            method: "post",
            url,
          }).then((res) => {
            const { code, data } = res.data
            if (code === "10000") {
              // 可以解析出以下数据 countries currencies regions
              state.basicRegions = data
              setDataItem('basicRegions', state.basicRegions, 'datasource')
            }
          });
        }
      }, 0)
    },
    [datasource.SET_MERCHANT_NO]: (state, value) => {
      state.merchantNo = value
    }
  },
  actions: {
    GetBasicDropdown({ commit }) { commit(datasource.SET_BASIC_DROPDOWN) },
    GetBasicRegions({ commit }) { commit(datasource.SET_BASIC_REGIONS) },
    SetMerchantNo({ commit }, value) { commit(datasource.SET_MERCHANT_NO, value) }
  }
}
